export interface AuthUser {
  id: number
  username: string
  email: string
  full_name: string
  role: Role[]
  is_active: boolean
}

export enum Role {
  ADMIN = 'admin',
  TUTOR = 'tutor',
  STUDENT = 'student',
}

export enum CreatedType {
  MOODLE = "MOODLE",
  MANUAL = "MANUAL"
}

export enum LoginSite {
  STUDENT = "STUDENT",
  TUTOR = "TUTOR",
}

export interface LoginRequest {
  username?: string
  password?: string
  created_type: CreatedType
  site?: LoginSite
  website?: string
}

// export interface LoginResponse {
//   status: boolean
//   message: string
//   data: { user: AuthUser; accessToken: string; refreshToken: string } | any
// }

export interface LoginResponse {
  access_token: string
  refresh_token: string
  token_type: string
  user: AuthUser
  authorization_url: string
  state: string
  message: string
}

export interface ExchangeTokenRequest {
  code: string
}

export interface ExchangeTokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
  user: AuthUser
  account_type: CreatedType
}

export interface RefreshResponse {
  access_token: string
  token_type: string
}
// export interface TokenPayload {
//   access_token: string
//   token_type: string
//   user: AuthUser
// }

// export interface RefreshResponse {
//   status?: boolean
//   data?: { accessToken?: string }
// }

export interface RegisterRequest {
  username: string
  full_name: string
  email: string
  password: string
  confirm_password: string
  created_type: CreatedType
  user_role: Role
}

export interface RegisterResponse {
  username: string
  email: string
  user_role: Role
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface ForgotPasswordRequest {
  email: string
  role: Role
}

export interface ResetPasswordRequest {
  token: string
  new_password: string
}

export interface ChangeEmailAndPasswordRequest {
  new_email?: string
  old_password?: string
  new_password?: string
}